import React from "react";
import { Grid } from "@mui/material";
import { FormInput } from "../../../components";

const AuthForm = ({
  usernameAuth,
  setUsernameAuth,
  emailAuth,
  setEmailAuth,
  passwordInput,
  setPasswordInput,
  errors,
  setErrors,
}) => {
  return (
    <Grid container spacing={2} alignItems="center">
      <Grid item xs={12} sm={12}>
        <FormInput
          label="Username"
          name="usernameAuth"
          size="medium"
          disabled={true}
          error={!!errors.usernameAuth}
          helperText={errors.usernameAuth}
          value={usernameAuth}
          onChange={(event) => {
            setUsernameAuth(event.target.value);
            if (errors.usernameAuth) {
              const newErrors = { ...errors };
              delete newErrors.usernameAuth;
              setErrors(newErrors);
            }
          }}
        />
      </Grid>

      {/* <Grid item xs={12} sm={12}>
        <FormInput
          label="Email"
          name="emailAuth"
          size="medium"
          value={emailAuth}
          onChange={(event) => {
            setEmailAuth(event.target.value);
          }}
        />
      </Grid> */}

      <Grid item xs={12} sm={12}>
        <FormInput
          label="Password"
          name="passwordInput"
          type="password"
          size="medium"
          error={!!errors.passwordInput}
          helperText={errors.passwordInput}
          value={passwordInput}
          onChange={(event) => {
            setPasswordInput(event.target.value);
            if (errors.passwordInput) {
              const newErrors = { ...errors };
              delete newErrors.passwordInput;
              setErrors(newErrors);
            }
          }}
        />
      </Grid>
    </Grid>
  );
};

export default AuthForm;
